function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.1189 7.15646C11.3895 6.90672 11.4063 6.48495 11.1566 6.2144C10.9068 5.94385 10.4851 5.92698 10.2145 6.17672C9.47974 6.85499 8.63705 7.6979 7.98204 8.36684C7.73891 8.61514 7.52069 8.84045 7.34222 9.0258L7.31515 8.99744C7.00193 8.66999 6.57035 8.23809 6.10572 7.83154C5.82863 7.58908 5.40745 7.61716 5.165 7.89425C4.92254 8.17134 4.95062 8.59252 5.22771 8.83497C5.65198 9.2062 6.05373 9.60763 6.35162 9.91907C6.49992 10.0741 6.62105 10.2053 6.70467 10.2973C6.74646 10.3433 6.7788 10.3794 6.80042 10.4036L6.8246 10.4309L6.83033 10.4374L6.83175 10.439C6.95543 10.5803 7.13297 10.6629 7.32072 10.6665C7.50851 10.67 7.68935 10.594 7.81832 10.4574L7.83889 10.4357L7.90052 10.3707C7.95444 10.314 8.03325 10.2313 8.13242 10.1279C8.33079 9.92087 8.61034 9.63096 8.93472 9.29967C9.58527 8.63528 10.4093 7.81152 11.1189 7.15646Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00004 1.33325C11.682 1.33325 14.6667 4.31803 14.6667 7.99992C14.6667 11.6818 11.682 14.6666 8.00004 14.6666C4.31807 14.6666 1.33337 11.6818 1.33337 7.99992C1.33337 4.31803 4.31807 1.33325 8.00004 1.33325ZM8.00004 2.66659C5.05457 2.66659 2.66671 5.05436 2.66671 7.99992C2.66671 10.9455 5.05457 13.3333 8.00004 13.3333C10.9455 13.3333 13.3334 10.9455 13.3334 7.99992C13.3334 5.05436 10.9455 2.66659 8.00004 2.66659Z"
});

var SvgCheckCircle = function SvgCheckCircle(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#939BA1"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/check-circle.d94c9b38.svg";
export { SvgCheckCircle as ReactComponent };